import apiClient from './Api';
const PREFIX = '/exportdms';

const createExportDMS = postData => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'POST',
    data: postData
  });
};

const deleteExportDMS = postData => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'DELETE',
    data: postData
  });
};

const listExportDMS = () => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'GET'
  });
};

const exportInventory = queryParams => {
  return apiClient({
    url: `/cron/createCSVFromDmsconfig`,
    method: 'GET',
    params: new URLSearchParams(queryParams)
  });
};

const verifyConnections = postData => {
  return apiClient({
    url: `${PREFIX}/verifyConnections`,
    method: 'POST',
    data: postData
  });
};

// -DMSConfig

const createDMSConfig = postData => {
  return apiClient({
    url: `${PREFIX}/dmsconfig`,
    method: 'POST',
    data: postData
  });
};

const listDMSConfig = postData => {
  return apiClient({
    url: `${PREFIX}/dmsconfig`,
    method: 'GET',
    params: postData
  });
};

const downloadLatestDMSFile = queryParams => {
  return apiClient({
    url: `${PREFIX}/downloadexportfies`,
    method: 'GET',
    params: new URLSearchParams(queryParams),
    responseType: 'blob'
  });
};

const exportDMSService = {
  createExportDMS,
  listExportDMS,
  deleteExportDMS,
  exportInventory,
  verifyConnections,
  downloadLatestDMSFile,

  // -DMSConfig
  createDMSConfig,
  listDMSConfig
};

export default exportDMSService;
